export default "__VITE_ASSET__DC05qVWG__"